import { createStyles, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import * as React from "react";

import {
    SalaryDistributionGraph,
    EnhancedTable,
    RelodeTheme,
    useDeviceSize,
} from "../../..";
import { useMarketResearchContext } from "../_infra/marketResearchProvider";
import { MarketResearchError } from "../shared/marketResearchError";

const useStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        container: {
            flexGrow: 1,
            overflow: "auto",
        },
    })
);

export const MarketResearchCompensation = () => {
    const classes = useStyles({});

    const {
        compensation: {
            error: compensationError,
            data: compensationData,
            isBusy: compensationIsBusy,
        },
    } = useMarketResearchContext();

    const device = useDeviceSize();

    if (!!compensationError) {
        return (
            <MarketResearchError
                title="compensation"
                error={compensationError}
            />
        );
    }

    if (compensationIsBusy || !compensationData) {
        return <CompensationSkeleton />;
    }

    const isLocationRemote = compensationData?.isRemote;

    return (
        <div className={classes.container}>
            <SalaryDistributionGraph
                data={compensationData.regionalGraphData}
                jobSalary={
                    !!compensationData.jobSalaryPercentile
                        ? {
                              percentile: compensationData.jobSalaryPercentile,
                              salary: compensationData.annualJobSalaryInUSDollars,
                          }
                        : null
                }
                mobile={device === "mobile"}
            />
            <div>
                <EnhancedTable
                    columns={[
                        {
                            field: "location",
                            title: "percentiles",
                            align: "left",
                        },
                        {
                            field: "10",
                            title: "10th",
                            align: "right",
                        },
                        {
                            field: "25",
                            title: "25th",
                            align: "right",
                        },
                        {
                            field: "50",
                            title: "50th",
                            align: "right",
                        },
                        {
                            field: "75",
                            title: "75th",
                            align: "right",
                        },
                        {
                            field: "90",
                            title: "90th",
                            align: "right",
                        },
                    ]}
                    data={
                        isLocationRemote
                            ? compensationData.percentiles.filter(
                                  p => p.location === "National"
                              )
                            : compensationData.percentiles
                    }
                    options={{
                        hideCheckbox: true,
                        boldColumnHeaders: false,
                        boldColumnValues: false,
                    }}
                    dataCy={"marketResearchCompensation"}
                />
            </div>
        </div>
    );
};

const CompensationSkeleton = () => (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Skeleton variant="rect" height={128} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
        <Skeleton variant="rect" height={24} style={{ marginBottom: 8 }} />
    </div>
);
